import { Component, effect, inject, Input, signal } from '@angular/core';
import { KpiService } from 'src/app/shared/services/kpi.service';

@Component({
  selector: 'app-global-kpi-env',
  templateUrl: './global-kpi-env.component.html',
  styleUrls: ['./global-kpi-env.component.sass'],
})
export class GlobalKpiEnvComponent {
  @Input() header: string;
  @Input() companyType: string;

  bannerData = signal<any>(null);
  tableData = signal<any>(null);

  kpi = inject(KpiService);

  currentYear = new Date().getFullYear();

  tableIllustration = '';

  constructor() {
    effect(() => {
      if (this.kpi.newCompaniesState()) {
        this.bannerData.set(this.kpi.summedTotalState()[this.companyType]);
        this.tableData.set(this.kpi.newCompaniesState());
        // const alternativeMethodForTableData = this.kpi.newCompaniesState().map(s => {
        //   return {
        //     environment: s.environment,
        //     data: s.data[this.companyType]
        //   }
        // });
      }
    }, {allowSignalWrites: true});
  }
}
